export default __webpack_public_path__ + "2eaaefb9fd3a66e3cd63f5667adc03de.svg";